import useCustomTheme from '../hooks/theme-hook';
import { StylesHelper } from '../models/helpers/stylesHelper';

const myRewardsStyles = () => {
  const theme = useCustomTheme();
  let myRewardsStyle = {
    cashoutContainer: {
      flexDirection: 'row' as any,
      backgroundColor: theme.background.missionDetail.toString(),
      ...StylesHelper.borderRadius(8),
      ...StylesHelper.padding(16),
      flexGrow: 1,
      flexShrink: 1,
      marginTop: 16,
    },
    cashoutSummary: {
      flexGrow: 1,
      flexShrink: 1,
    },
    cashoutActionsContainer: {
      alignItems: 'center' as const,
      marginTop: 16,
    },
    cashoutAlertContainer: {
      ...StylesHelper.padding(16),
      width: '100%' as const,
    },
    cashoutAlert: {
      flexDirection: 'row' as const,
      gap: 16,
      alignItems: 'center' as const,
      backgroundColor: theme.colorErrorPrimaryBackground,
      ...StylesHelper.padding(12, 16),
      ...StylesHelper.borderRadius(8),
      flexGrow: 1,
    },
    cashoutAlertIcon: {
      flexShrink: 0,
    },
    cashoutAlertMessageContainer: {
      flexShrink: 1,
    },
    cashoutAlertMessage: {
      fontSize: 14,
      color: theme.colorErrorPrimary,
      fontWeight: '600' as const,
    },
    cashoutButtonRow: {
      flexDirection: 'row' as const,
    },
    cashoutButtonDisabled: {
      backgroundColor: theme.background.primaryLight,
      borderColor: theme.secondaryLight,
      opacity: 0.9,
    },
    cashoutButtonDisabledText: {
      color: theme.text.primary,
      fontWeight: '700' as const,
    },
    cashoutLoadingContainer: {
      alignItems: 'center' as const,
      minHeight: 50,
    },
    cashoutValueProgress: {
      // width: 60,
      ...StylesHelper.padding(0, 0, 0, 8),
      flexGrow: 0,
      flexShrink: 1,
      height: '100%' as any,
    },
    cashoutValueProgressBar: {
      flexDirection: 'column' as any,
      backgroundColor: 'transparent' as any,
      ...StylesHelper.borderRadius(50),
      overflow: 'hidden',
      flexShrink: 1,
      width: 28,
    },
    cashoutValueProgressBarMarkers: {
      height: '80%' as any,
      width: 35,
      display: 'flex' as any,
      flexDirection: 'column' as any,
      alignItems: 'flex-start' as any,
      justifyContent: 'space-between' as any,
      marginTop: -5,
    },
    cashoutValueProgressBarFill: {
      flexGrow: 1,
      flexShrink: 1,
      width: 28,
    },
    cashoutValueProgressBarBack: {
      flexGrow: 1,
      flexShrink: 1,
      width: 28,
    },
    cashoutTotalPoints: {
      fontSize: 44,
      color: theme.text.titleDark,
      fontWeight: '800' as any,
      alignSelf: 'center' as any,
    },
    cashoutTotalPointsLabel: {
      fontSize: 16,
      color: theme.text.titleDark,
      fontWeight: '800' as any,
      alignSelf: 'center' as any,
    },
    cashoutPointsRemaining: {
      textAlign: 'center' as any,
      color: theme.text.titleDark,
      ...StylesHelper.padding(16, 8, 16, 0),
      fontSize: 12,
    },
    pointsExplanation: {
      marginTop: 16,
      ...StylesHelper.padding(0, 16),
      paddingBottom: 24
    },
    pointsExplanationTitle: {
      marginBottom: 8,
      fontSize: 15,
    },
    waysOfWin: {
      flexDirection: 'column' as any,
      backgroundColor: theme.background.missionDetail.toString(),
      ...StylesHelper.borderRadius(8),
      ...StylesHelper.padding(16),
      flexGrow: 1,
      flexShrink: 1,
      marginTop: 32,
    },
    waysOfWinTitle: {
      flexDirection: 'row' as any,
      alignItems: 'center' as any,
      marginBottom: 16,
    },
    waysOfWinItems: {
      flexDirection: 'column' as any,
    },
    waysOfWinItem: {
      flexDirection: 'row' as any,
    },
  };

  return myRewardsStyle as typeof myRewardsStyle;
};
export default myRewardsStyles;
